// extracted by mini-css-extract-plugin
export default {"container":"CardsContainer_container__Y+Tms"};